import { useCallback } from 'react';
import { useCreateCropReport } from '/@/hooks/reports';
import type { Field } from '/@/types/field';

const useFieldviewReports = ({ field }: { field: Field }) => {
    const createApplicationReportMutation = useCreateCropReport({ field: field.id, type: 'application' });
    const createPlantingReportMutation = useCreateCropReport({ field: field.id, type: 'planting' });
    const createHarvestReportMutation = useCreateCropReport({ field: field.id, type: 'harvest' });

    const applicationTrigger = createApplicationReportMutation.trigger;
    const plantingTrigger = createPlantingReportMutation.trigger;
    const harvestTrigger = createHarvestReportMutation.trigger;

    const createReports = useCallback(() => {
        applicationTrigger();
        plantingTrigger();
        harvestTrigger();
    }, [applicationTrigger, plantingTrigger, harvestTrigger]);

    return {
        createReports,
        isMutating:
            createApplicationReportMutation.isMutating ||
            createPlantingReportMutation.isMutating ||
            createHarvestReportMutation.isMutating,
        error:
            createApplicationReportMutation.error ||
            createPlantingReportMutation.error ||
            createHarvestReportMutation.error,
    };
};

export default useFieldviewReports;
